import React from 'react';
import PropTypes from 'prop-types';
import { AllhomesGlobalContextProvider, withAllhomesProvider } from '@domain-group/fe-co-allhomes-global-context';
import contextFactory from './context-factory';
import GraphQLProvider from './graphql/graphql-provider';
import withGraphQLProvider from './graphql/with-graphql-provider';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesApiProvider = props => ___EmotionJSX(AllhomesGlobalContextProvider, {
  contextFactory: contextFactory,
  isEuUser: props.isEuUser,
  isProduction: props.isProduction,
  reloadOnLogin: props.reloadOnLogin,
  initialUsername: props.initialUsername,
  initialAuthState: props.initialAuthState,
  authToken: props.authToken,
  endpoints: props.endpoints,
  toggledFeatures: props.toggledFeatures,
  activeExperiments: props.activeExperiments,
  absoluteUrlBase: props.absoluteUrlBase,
  apolloClient: props.apolloClient,
  debug: props.debug,
  pageContext: props.pageContext
}, ___EmotionJSX(GraphQLProvider, null, props.children));
AllhomesApiProvider.propTypes = {
  children: PropTypes.node.isRequired,
  reloadOnLogin: PropTypes.bool,
  debug: PropTypes.bool,
  isProduction: PropTypes.bool,
  isEuUser: PropTypes.bool,
  initialUsername: PropTypes.string,
  initialAuthState: PropTypes.string,
  authToken: PropTypes.string,
  endpoints: PropTypes.shape({}),
  pageContext: PropTypes.objectOf(PropTypes.shape({})),
  toggledFeatures: PropTypes.objectOf(PropTypes.bool),
  activeExperiments: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    variant: PropTypes.string
  })),
  absoluteUrlBase: PropTypes.string,
  apolloClient: PropTypes.shape({})
};
AllhomesApiProvider.defaultProps = {
  reloadOnLogin: false,
  debug: false,
  isProduction: true,
  isEuUser: false,
  initialUsername: undefined,
  initialAuthState: undefined,
  authToken: undefined,
  endpoints: {},
  pageContext: {},
  toggledFeatures: {},
  activeExperiments: [],
  absoluteUrlBase: undefined,
  apolloClient: undefined
};
export var withAllhomesApiProvider = function withAllhomesApiProvider() {
  return withAllhomesProvider(contextFactory)(withGraphQLProvider(...arguments));
};
export default AllhomesApiProvider;